export default "__VITE_ASSET__e08b81ca__"